import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getCoupons = (dateRange = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/coupons`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const createCouponRequest = (couponData) =>
  axiosInstance.post(`${ADMIN_API_URL}/coupons`, couponData, {
    headers: authHeaders(),
  });

export const updateCouponRequest = (couponId, couponData) =>
  axiosInstance.post(`${ADMIN_API_URL}/coupons/${couponId}`, couponData, {
    headers: authHeaders(),
  });

export const removeCoupon = (couponId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/coupons/${couponId}`, {
    headers: authHeaders(),
  });
